import { render, staticRenderFns } from "./SocialSectionInstagramSlider.vue?vue&type=template&id=27f32c38"
import script from "./SocialSectionInstagramSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./SocialSectionInstagramSlider.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports